import axios from 'axios';
import { BASE_URL } from '../ApiService/ApiConfig';

const obtenerConfig = () => {
    const token = localStorage.getItem('jwt').replaceAll('"', '');
    return {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            Authorization: 'Bearer ' + token
        }
    };
};

const URL = `${BASE_URL}/rutaGuardada`;

export const listarMisRutas = async () => {
    const response = await axios.get(`${URL}/usuario`, obtenerConfig());
    return response.data;
};

export const obtenerRutaPorId = async (rutaGuardadaId) => {
    const response = await axios.get(`${URL}/${rutaGuardadaId}`, obtenerConfig());
    return response.data;
};

export const crearRuta = async (objData) => {
    const response = await axios.post(URL, objData, obtenerConfig());
    return response.data;
};

export const actualizarRuta = async (objData) => {
    const response = await axios.put(URL, objData, obtenerConfig());
    return response.data;
};

export const anularRuta = async (rutaGuardadaId) => {
    const response = await axios.get(`${URL}/anular/${rutaGuardadaId}`, obtenerConfig());
    return response.data;
};

export const marcarConsulta = async (rutaGuardadaId) => {
    const response = await axios.get(`${URL}/marcarConsulta/${rutaGuardadaId}`, obtenerConfig());
    return response.data;
};
